import { render } from "./NewOrderData.vue?vue&type=template&id=286640c2&scoped=true&ts=true"
import script from "./NewOrderData.ts?vue&type=script&lang=ts"
export * from "./NewOrderData.ts?vue&type=script&lang=ts"

import "./NewOrderData.vue?vue&type=style&index=0&id=286640c2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286640c2"]])

export default __exports__